import React from 'react';

const IconGreetingHand = props => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="12"
      fill="none"
      viewBox="0 0 9 12"
    >
      <g clipPath="url(#clip0_2112_2952)">
        <path
          fill="#F8F8F8"
          stroke="#F8F8F8"
          strokeWidth="0.2"
          d="M2.375.913a.933.933 0 0 1 .947.436l.11.181a.91.91 0 0 1 .996-.428l.09.026a.93.93 0 0 1 .496.398l1.592 2.59.01-.166a.928.928 0 0 1 1.85-.065l.324 3.504.001.002v.005l.002.022.008.08.023.255c.037.415.06.842-.1 1.311-.215.638-.603 1.106-1.246 1.515l-.253.161-.016.009c-.423.23-.896.351-1.377.352-1.22 0-2.373-.763-2.99-1.774L.665 5.762a.954.954 0 0 1 .293-1.298h.001a.9.9 0 0 1 .412-.139l-.31-.508a.954.954 0 0 1 .293-1.297h.001a.9.9 0 0 1 .413-.14l-.024-.038a.956.956 0 0 1 .292-1.298l.001-.001a.9.9 0 0 1 .338-.13Zm.251.515a.42.42 0 0 0-.314.048.44.44 0 0 0-.131.598L4.768 6.31q.027.043.035.093a.26.26 0 0 1-.12.258l-.002.001a.26.26 0 0 1-.35-.084v-.002L2.201 3.091a.42.42 0 0 0-.573-.138.44.44 0 0 0-.168.52l.038.077 2.128 3.484a.26.26 0 0 1 .031.194.26.26 0 0 1-.116.159h-.001a.26.26 0 0 1-.35-.084L3.188 7.3 1.806 5.035a.42.42 0 0 0-.574-.138.44.44 0 0 0-.13.597L3.28 9.06c.735 1.202 2.313 1.974 3.682 1.24l.241-.152C7.75 9.8 8.065 9.416 8.24 8.9c.125-.37.109-.71.074-1.102-.008-.099-.097-1.063-.184-2.004l-.12-1.282-.038-.418-.011-.116-.003-.032v-.01a.416.416 0 0 0-.83.034v.005l-.052.99a.258.258 0 0 1-.353.224.26.26 0 0 1-.121-.103c-.31-.508-2-3.253-2.023-3.291v-.001a.4.4 0 0 0-.185-.165l-.08-.026a.4.4 0 0 0-.307.051.44.44 0 0 0-.132.598l2.034 3.331a.256.256 0 0 1-.085.352h-.002a.26.26 0 0 1-.35-.083V5.85L2.885 1.616a.42.42 0 0 0-.259-.188Z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2112_2952">
          <path fill="#fff" d="M0 0h9v12H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconGreetingHand;
